export type AmenityView = {
  id: number;
  name: string;
  textResourceKey: string;
  amenityGroupId: number;
  amenityGroupName: string;
  amenitySortOrder: number;
  isPropertyLevelAmenity: boolean;
  isAccomodationUnitTypeLevelAmenity: boolean;
  userShouldSetIsFreeAttribute: boolean;
  userShouldSetIsOnSiteAttribute: boolean;
  userShouldSetEmphasizeOnBEAttribute: boolean;
  notes: string;
};

export class AmenityViewModel {
  id = 0;
  name = "";
  textResourceKey = "";
  amenityGroupId = 0;
  amenityGroupName = "";
  amenitySortOrder = 0;
  userShouldSetIsFreeAttribute = false;
  userShouldSetIsOnSiteAttribute = false;
  userShouldSetEmphasizeOnBEAttribute = false;
  isPropertyLevelAmenity = false;
  isAccomodationUnitTypeLevelAmenity = false;
  isSelected = false;
  isFree?: boolean;
  isOnSite?: boolean;
  emphasizeOnBookingPortal = false;
  notes = "";
}

export class AmenityModel {
  amenityId = 0;
  notes = "";
  isFree? = false;
  isOnSite? = false;
  emphasizeOnBookingPortal = false;
}

export type AmenityGroup = {
  id: number;
  name: string;
  textResourceKey: string;
  sortOrder: number;
};